import React from "react";

const HeadTailResult = ({ resultData }) => {
    // Split into rows of 10 (50 results = 5 rows)
    const rows = [];

    for (let i = 0; i < resultData.length; i += 10) {
        rows.push(resultData.slice(i, i + 10));
    }

    return (
        <div
            style={{
                background: "#2d2b2b",
                border: "2px solid #d8d8d8",
                borderRadius: "15px",
                padding: "14px",
                margin: "15px"
            }}
        >
            <div
                style={{
                    background: "#1976f2",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "18px",
                    padding: "9px 15px",
                    borderRadius: "8px",
                    marginBottom: "15px"
                }}
            >
                Results for Last 50 Rounds
            </div>

            {rows.map((row, rowIndex) => (
                <div
                    key={rowIndex}
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "30px"
                    }}
                >
                    {row.map((item, index) => {
                        const resultText = String(item.resultTxt || "");
                        const isHead =
                            item.result === 1 ||
                            item.result === "1" ||
                            resultText === "Heads" ||
                            resultText === "Head";
                        const isTail =
                            item.result === 2 ||
                            item.result === "2" ||
                            resultText === "Tails" ||
                            resultText === "Tail";
                        if (!isHead && !isTail) {
                            return null;
                        }

                        return (
                            <div
                                key={index}
                                style={{
                                    width: "60px",
                                    height: "35px",
                                    borderRadius: "5px",
                                    border: `1px solid ${isHead
                                        ? "#ff5a00"
                                        : "#27ff72"
                                        }`,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "18px",
                                    color: "#fff",
                                    background: "#2d2b2b"
                                }}
                            >
                                {isHead ? "H" : "T"}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default HeadTailResult;